// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__BJUul"};